import { useQuery } from '@tanstack/react-query';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { GetOrganizationAccessResponse } from '@upright/common/iam/organizations/organization-types';

export function useOrganizationAccess(organizationId?: number) {
  const query = useQuery({
    queryKey: ['get-organization-access', organizationId],
    queryFn: async () => {
      return await fetchOrThrow<GetOrganizationAccessResponse>(`/organizations/${organizationId}/access`);
    },
    enabled: !!organizationId,
  });

  return {
    isLoading: query.isLoading,
    ...query.data,
  };
}
